<template>
  <span class="arrow-box" ref="arrow">
    <span class="t--ft" v-if=!bracketOff>(</span>
    <span :class="[
    'target-arrow',
     dir === 'up' ? 'target-arrow--up' : dir ==='down'?'target-arrow--down' : 'target-arrow--right'
    ]"
    >
        <span class="t--fak fake">{{ data.arrowText }}</span>
        <span :class="[
        't--fak',
        'moving',
        'moving--1',
        {'out':data.out},
        {'in': data.in}
        ]">
        {{ data.arrowText }}
        </span>
        <span :class="[
        't--fak',
        'moving',
        'moving--2',
        {'out':data.out},
        {'in': data.in}

        ]">{{ data.arrowText }}</span>
        <!-- <span class="t--fak moving moving--3">{{ data.arrowText }}</span> -->
    </span>
    <!-- <span class="target-arrow target-arrow--2">↗</span> -->

    <span class="t--ft" v-if=!bracketOff>)</span>
  </span>
</template>
<script>
import * as $ from "fxdom";
import * as _ from "fxjs";
import { ref, reactive, computed, onMounted } from "@/helper/vue.js";
export default {
  props: {
    dir: {
      type: String,
      default: 'right'
    },
    bracketOff: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const data = reactive({
      arrowText: props.dir === 'up' ? '↗' : props.dir ==='down' ? '↘' : '→',
      out: false,
      in: false
    })
    const methods = {
      over:()=>{
        data.out = false
        data.in = true
      },
      leave:()=>{
        data.out = true
        data.in = false
      },
      addEvent: (target) => {
        target.addEventListener('mouseenter', e => {
          methods.over();
        });
        target.addEventListener('mouseleave', e => {
          methods.leave()
        });
      }
    }
    const arrow =ref();
    onMounted(()=>{
      const targetImgP = $.closest(".i--arrow-ov-img", arrow.value);
      if (targetImgP) {
        const targetImg = $.qs(".m-pic__source", targetImgP);
        if($.qsa('.arrow-box', $.closest('.i--ovLink', arrow.value))[0] == arrow.value) {
          methods.addEvent(targetImg);
        }
      }

      let targetP = $.closest(".c-arrow-effect",arrow.value)
      methods.addEvent(targetP);
    })
    return {
      data,
      methods,
      arrow
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin animaition-mixin-up-1($name, $first, $middle, $last){
  @keyframes #{$name}{
    0% {
      top: $first;
      left: $first;
    }
    50% {
      top: -$middle;
      left: $middle;
    }
    100% {
      top: -$last;
      left: $last;
    }
  }
}
@mixin animaition-mixin-up-2($name, $first, $middle, $last){
  @keyframes #{$name}{
    0% {
      left: -$first;
      top: $first;;
    }
    50% {
      left: -$middle;
      top: $middle;
      
    }
    100% {
      left: $last;
      top: $last;
    }
  }
}
@mixin animaition-mixin-down-1($name, $first, $middle, $last){
  @keyframes #{$name} {
    0% {
      left: $first;
      bottom: $first;
    }
    50% {
      left: $middle;
      bottom: -$middle;
    }
    100% {
      left: $last;
      bottom: -$last;
    }
  }
}
@mixin animaition-mixin-down-2($name, $first, $middle, $last){
  @keyframes #{$name} {
    0% {
      left: -$first;
      bottom: $first;
    }
    50% {
      left:-$middle;
      bottom: $middle;
    }
    100% {
      left: $last;
      bottom: $last;
    }
  }
}
@mixin animaition-mixin-right-1($name, $first, $middle, $last){
  @keyframes #{$name} {
    0% {
      left: $first;
    }
    50% {
      left: $middle;
    }
    100% {
      left: $last;
    }
  }
}
@mixin animaition-mixin-right-2($name, $first, $middle, $last){
  @keyframes #{$name} {
    0% {
      left: -$first;
    }
    50% {
      left:-$middle;
    }
    100% {
      left: $last
    }
  }
}


@include animaition-mixin-up-1(arrow-movement-up-1, 0%,50%,100%);
@include animaition-mixin-up-1(arrow-movement-up-1-1, 0%,50%,100%);
@include animaition-mixin-up-2(arrow-movement-up-2, 100%,50%,0%);
@include animaition-mixin-up-2(arrow-movement-up-2-1, 100%,50%,0%);
@include animaition-mixin-down-1(arrow-movement-down-1, 0%,50%,100%);
@include animaition-mixin-down-1(arrow-movement-down-1-1, 0%,50%,100%);
@include animaition-mixin-down-2(arrow-movement-down-2, 100%,50%,0%);
@include animaition-mixin-down-2(arrow-movement-down-2-1, 100%,50%,0%);
@include animaition-mixin-right-1(arrow-movement-right-1, 0%,50%,100%);
@include animaition-mixin-right-1(arrow-movement-right-1-1, 0%,50%,100%);
@include animaition-mixin-right-2(arrow-movement-right-2, 100%,50%,0%);
@include animaition-mixin-right-2(arrow-movement-right-2-1, 100%,50%,0%);

.c-arrow-effect {
  .target-arrow {
    &--up {
      .moving {
        opacity: 1;
        &.in {
          &.moving--1 {
          animation-name: arrow-movement-up-1;
          }
          &.moving--2 {
            animation-name: arrow-movement-up-2;
          }  
        }
      }
    }
    &--down {
      .moving {
      opacity: 1;
        &.in {
          &.moving--1 {
          animation-name: arrow-movement-down-1;
          }
          &.moving--2 {
            animation-name: arrow-movement-down-2;
          }  
        }
      }
    }
    &--right {
      .moving {
      opacity: 1;
        &.in {
          &.moving--1 {
          animation-name: arrow-movement-right-1;
          }
          &.moving--2 {
            animation-name: arrow-movement-right-2;
          }  
        }
      }
    }
    .fake {
      opacity: 0;
    }
  }
}
.arrow-box {
    display: inline-flex;
    position: relative;
    overflow: hidden;
    .fake {
      opacity: 0;
    }
    .target-arrow {
      display: inline-block;
      position: relative;
      overflow: hidden;
      .moving {
        position: absolute;
        &--1 {
          left: 0;
        }
        // opacity: 0;
      }
        &--up {
          .moving {
            animation-duration: 0.4s;
            animation-timing-function: linear;
            &.out {
              &.moving--1 {
              animation-name: arrow-movement-up-1-1;
              }
              &.moving--2 {
                animation-name: arrow-movement-up-2-1;
              }
            }
          }
        }
        &--down {
          .moving {
            animation-duration: 0.4s;
            animation-timing-function: linear;
            &.out {
              &.moving--1 {
              animation-name: arrow-movement-down-1-1;
              }
              &.moving--2 {
                animation-name: arrow-movement-down-2-1;
              }
            }
          }
        }
        &--right {
          .moving {
            animation-duration: 0.4s;
            animation-timing-function: linear;
            &.out {
              &.moving--1 {
              animation-name: arrow-movement-right-1-1;
              }
              &.moving--2 {
                animation-name: arrow-movement-right-2-1;
              }
            }
          }
        }
    }
  }
</style>